import * as React from "react";
import { IconButton, IconButtonProps } from "@radix-ui/themes";
import { Cross2Icon } from "@radix-ui/react-icons";

interface Props extends IconButtonProps {}

export const DialogCloseButton: React.FC<Props> = ({ children, style, ...rest }) => {
  return (
    <IconButton
      variant={"ghost"}
      color={"gray"}
      aria-label="Close"
      style={{
        position: "absolute",
        top: "18px",
        right: "18px",
        ...style,
      }}
      {...rest}
    >
      <Cross2Icon width={"18px"} height={"18px"} />
      {children}
    </IconButton>
  );
};
